import React, { Component } from 'react'
import { Link } from 'react-router'

import classNames from './Header.css'
import Icon from './Icon'

const MATCH_LOGIN_PATH = /^\/?(login|share\/)/
const MATCH_BACK_PATH = /^\/?(image|timeline|queues|playlists|groups?)\/.+/
const MATCH_QUEUES = /^\/?queues\/.+/
const MATCH_PLAYLISTS = /^\/?playlists\/.+/
const MATCH_CHANNELS = /^\/?channels\/.+/
const MATCH_ALBUM_PATH = /^\/?album[^s]?/
const MATCH_ALBUM_LIST_PATH = /^\/?list\/.+/
const MATCH_ALBUM_EDIT_PATH = /^\/?album\/.+\/edit$/
const MATCH_SEARCH_PATH = /^\/?search$/

export default class Header extends Component {
  render () {
    const { props } = this
    let className = classNames.header
    if (props.path === '/') {
      className = classNames.headerHome
    }
    if (MATCH_ALBUM_PATH.test(props.path) && !MATCH_ALBUM_EDIT_PATH.test(props.path)) {
      className = classNames.headerAlbum
    }
    if (MATCH_ALBUM_EDIT_PATH.test(props.path) || MATCH_SEARCH_PATH.test(props.path)) {
      className = classNames.headerAlbumEdit
    }
    if (MATCH_QUEUES.test(props.path)) {
      className = classNames.headerQueues
    }
    if (MATCH_PLAYLISTS.test(props.path)) {
      className = classNames.headerPlaylists
    }
    if (MATCH_CHANNELS.test(props.path)) {
      className = classNames.headerChannels
    }
    if (MATCH_LOGIN_PATH.test(props.path)) {
      return <header className={classNames.headerLogin} />
    }
    return (
      <header className={className}>
        <LeftIcon {...props} />
        <h1 className={classNames.title}>{props.title}</h1>
        {RightIcon(props)}
      </header>
    )
  }
}

function LeftIcon ({ path, previousPath, toggleNav, anonymousUser }) {
  if (MATCH_LOGIN_PATH.test(path)) {
    return null
  }
  if (shouldDisplayBackButton(path, previousPath)) {
    return (
      <button className={classNames.backIcon} onClick={() => window.history.back()}>
        <Icon icon='chevron-left' size={32} />
      </button>
    )
  }
  return (
    <button className={classNames.icon} onClick={toggleNav}>
      <Icon icon='bars' size={24} />
    </button>
  )
}

function RightIcon ({ path, previousPath, params, anonymousUser, canSearch }) {
  if (MATCH_LOGIN_PATH.test(path)) {
    return null
  }
  if (!canSearch || anonymousUser || shouldDisplayBackButton(path, previousPath)) {
    // Empty icon to ensure header title is centered
    return <Icon icon='' size={24} className={classNames.icon} />
  }
  let edit
  if (MATCH_ALBUM_LIST_PATH.test(path)) {
    edit = (
      <Link key='edit' className={classNames.icon} to={`/groups/${params.id}`}>
        <Icon icon='edit' size={18} />
      </Link>
    )
  }
  return [
    edit,
    <Link key='search' className={classNames.icon} to='/search'>
      <Icon icon='search' size={18} />
    </Link>
  ]
}

function shouldDisplayBackButton (path, previousPath) {
  if (window.history.length <= 1) {
    return false
  }
  if (previousPath === '/login') {
    return false
  }
  return MATCH_BACK_PATH.test(path)
}



// WEBPACK FOOTER //
// ./src/components/Header.js